var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button } from '@philips-internal/oswald-ui-components';
import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { object } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { bool, string } from 'prop-types';
import React, { Component } from 'react';
import CustomDynamicButtonAPI from './custom-dynamic-button-api';
import './custom-dynamic-button.css';
let CustomDynamicButton = class CustomDynamicButton extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            actions: this.props.actions,
            visible: this.props.visible
        };
    }
    static { this.propTypes = {
        actions: object.notEnumerable(),
        className: string,
        visible: bool,
    }; }
    static { this.defaultProps = {
        actions: [],
        visible: true
    }; }
    render() {
        const { className, actions, visible } = this.props;
        return (React.createElement("div", { hidden: !visible },
            React.createElement("div", { className: `c-global-actions-stack-manager c-custom-dynamic-button ${className}` }, actions && actions.map((action, index) => React.createElement(Button, { className: action.className, key: index, onClick: () => action.onClick(), theme: action.theme ? action.theme : ButtonTheme.PRIMARY, value: action.value, enabled: action.enabled })))));
    }
};
CustomDynamicButton = __decorate([
    AwesomeComponent({ api: CustomDynamicButtonAPI, type: ComponentType.DATA_DISPLAY })
], CustomDynamicButton);
export default CustomDynamicButton;
//# sourceMappingURL=custom-dynamic-button.js.map